(function ($, Drupal, drupalSettings) {
    'use strict';

    Theme.all = function (common, options) {
        // Héritage
        this.common = common;

        // Selecteurs
        this.selectors = {
            // EXEMPLES : Data,Hover; Focus...
        };

        // Éléments
        this.elements = {
            html: $('html'),
            body: $('body'),
            blockGalery: $('.paragraph--type--block-galery .galery--content'),
            blockSlider: $('.paragraph--type--block-slider'),
            blockThumbGallery: $('.paragraph--type--block-thumbs-gallery'),
            blockSliderMeats: $('.node--type--meat.node--view-mode--full .field_image_catalog'),
            blockTestimonials: $('.block-testimonials--content'),
            containerTestimonials: $('.paragraph--type--container-testimonials'),
        };

        // Variables
        this.toggleMenu = undefined;
        this.rellax = undefined;
        this.fixer = undefined;
    };

    Theme.all.prototype = {
        init: function () {
            this.initResponsive();
            this.initHeaderSticky();
            this.initMenuMain();
            this.initMenuSecondary();
            this.initMenuLanguage();
            //this.initBlockSearch();
            this.initBlockGalery();
            this.initBlockSlider();
            this.initBlockThumbsGallery();
            this.initSliderMeats();
            this.initBlockTestimonials();
            this.initContainerTestimonials();
            this.initBlockFaq();
            this.initBlockVideo();
            this.initBlockReinssurance();
            this.initBlockProductsCards();
            this.initSlidersForMobile(
                '.view-display-latest-news .view-list--wrapper'
            );

            // optionnel (désactivé) :
            // this.initEffectsOnScroll();
        },

        load: function () {
            console.log('load');

            this.initSlidersForMobile();
        },

        autoload: function (options) {
            console.log('autoload');
        },

        /**
         * initResponsive
         */
        initResponsive: function () {
            var all = Drupal.Theme.load('all');

            all.refreshResponsive();
            $(window).resize(function () {
                var all = Drupal.Theme.load('all');
                all.refreshResponsive();
            });
        },

        /**
         * initHeaderSticky
         */
        initHeaderSticky: function () {
            var all = Drupal.Theme.load('all');

            all.refreshHeaderSticky();

            $(window).on('scroll', function () {
                var all = Drupal.Theme.load('all');
                all.refreshHeaderSticky();
            });
        },

        /**
         * refreshResponsive
         */
        refreshResponsive: function () {
            this.refreshBlockProfessions();
            if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
                $('.pre-footer--wrapper').append($('.pre-footer--inner #block-menu-social-media'));
            }
            else {
                $('.pre-footer--inner').append($('.pre-footer--wrapper #block-menu-social-media'));
            }
        },

        /**
         * Block Professions
         */
        refreshBlockProfessions: function () {
            $('.block-professions').each(function() {
                let blockProfessionsMobile = $(this).find('.block-professions-mobile');

                if ($(window).outerWidth() < BREAKPOINT_PHABLET) {
                    if (!blockProfessionsMobile.length) {
                      blockProfessionsMobile = $(this).find('.block--wrapper').append('<div class="block-professions-mobile"/>')
                      $(this).find('.profession-box').each(function () {
                        $(this).find('.profession-inner').closest('.block-professions')
                          .find('.block-professions-mobile')
                          .append(
                            '<a class="profession" href="' + $(this).attr('href') + '">' +
                            $(this).find('.profession-inner').html() +
                            '</a>'
                          );
                      });
                    }

                    $(this).find('.professions-svg').hide();
                    blockProfessionsMobile.show();
                }
                else {
                    blockProfessionsMobile.hide();
                    $(this).find('.professions-svg').show();
                }
            });
        },

        /**
         * Block Menu Main
         */
        initMenuMain: function () {
            var all = Drupal.Theme.load('all');

            /** Menu mobile **/
            /* construction du menu mobile */
            //$('#block-menu-main').after($('#block-menu-main').clone().attr('id', 'block-menu-main-mobile'));
            /* déplacement autres menus dans menu mobile */
            /*$('#block-menu-main-mobile').prepend($('#block-menu-secondary .menu-secondary--items').clone());

            const menu = new MmenuLight(document.querySelector("#block-menu-main-mobile"));
            const navigator = menu.navigation({
                title:  'GM Starter Kit Drupal',
                theme:  'dark'
            });
            const drawer = menu.offcanvas({
                position: 'right'
            });*/

            $('body').on('click touch', ".btn-menu-main:not('.btn-close-menu-main-mobile')", function (e) {
                e.preventDefault();

                if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
                    //drawer.open();
                    $('body').toggleClass('menu-main-mobile-active');
                    window.scrollTo(0, 0);
                } else {
                    $('body').toggleClass('menu-main-active');
                }
            });
            $('body').on('click touch', '.btn-close-menu-main-mobile', function (e) {
                e.preventDefault();
                $('body').removeClass('menu-main-mobile-active');
            });


          $('body').on('mouseover', "#block-menu-main .level0--link", function (e) {
            e.preventDefault();

            if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
              $(this).closest('.level0').find('.level0--item').removeClass('hover');
              $(this).closest('.level0--item').addClass('hover');
            }
          });
          $('body').on('mouseover touch', function(e) {
            if (!e.target.closest('#block-menu-main')) {
              if ($('#block-menu-main .level0--item.hover').length) {
                setTimeout(function () {
                  $('#block-menu-main .level0--item').removeClass('hover');
                }, 300);
              }
            }
          });



            all.refreshMenuMain();
            $(window).resize(function () {
                var all = Drupal.Theme.load('all');
                all.refreshMenuMain();
            });
        },

        /**
         * refresh Menu Main
         */
        refreshMenuMain: function () {
            if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
                // construction du menu mobile
                $('body').removeClass('menu-main-active');
                if (!$('.page-inner > #block-menu-main').length) {
                  //$('.header-site-top').prepend($('#block-header-search'));
                  $('.page-inner').append($('#block-menu-main'));
                  $('#block-menu-main').append($('#block-selecteurdelangue'));
                  $('#block-menu-main').append($('#block-menu-secondary .menu-secondary--items'));

                  if (!$('.btn-close-menu-main-mobile').length) {
                    $('#block-menu-main').append($('.btn-menu-main').clone().addClass('btn-close-menu-main-mobile'));
                  }
                }
            } else {
              // destruction du menu mobile
              $('body').removeClass('menu-main-mobile-active');
              if ($('.page-inner > #block-menu-main').length) {
                $('.header-tools').prepend($('#block-selecteurdelangue'));
                $('#block-menu-secondary').append($('#block-menu-main .menu-secondary--items'));
                //$('#block-header-search').insertAfter('#block-menu-secondary');

                $('.header-site-top > .navigation').append($('#block-menu-main'));
              }
            }

            /*$('body').on('click touch', function (e) {
                if (!e.target.closest('#block-menu-main') && !e.target.closest('.btn-menu-main')) {
                    $('body').removeClass('menu-main-mobile-active');
                }
            });*/
        },

        /**
         * Block Menu Secondary
         */
        initMenuSecondary: function () {
            $('body').on('mouseover', "#block-menu-secondary .level0--link", function (e) {
                e.preventDefault();

                if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
                    $(this).closest('.level0').find('.level0--item').removeClass('hover');
                    $(this).closest('.level0--item').addClass('hover');
                }
            });
            $('body').on('mouseover touch', function(e) {
                if (!e.target.closest('#block-menu-secondary')) {
                    if ($('#block-menu-secondary .level0--item.hover').length) {
                        setTimeout(function () {
                            $('#block-menu-secondary .level0--item').removeClass('hover');
                        }, 300);
                    }
                }
            });
        },

        /**
         * Menu language
         */
        initMenuLanguage: function () {
            $('body').on('mouseover touch focus', '#block-selecteurdelangue .language-link', function (e) {
                e.preventDefault();
                $('#block-selecteurdelangue').addClass('open');
            });
            $('body').on('mouseout focusout', '#block-selecteurdelangue', function (e) {
                e.preventDefault();
                $(this).removeClass('open');
            });
        },

        /**
         * Block Search
         */
        /*initBlockSearch: function () {
            $('body').on('click touch', '.btn-display-search', function (e) {
                e.preventDefault();

                $('#block-header-search').toggleClass('active');
            });
        },*/

        /**
         * Block Galery
         */
        initBlockGalery: function () {
            var self = this;

            if (self.elements.blockGalery.length) {
                self.elements.blockGalery.masonry({
                    // options
                    //horizontalOrder: true,
                    percentPosition: true,
                });
            }
        },

        /**
         * Block Slider
         */
        initBlockSlider: function () {
            var self = this;

            if (self.elements.blockSlider.length) {
                self.elements.blockSlider.each(function () {

                    // récup param autoplay
                    var autoplayTimeout = 0;
                    $(this).attr('class').split(' ').forEach(function (item) {
                        if (item.indexOf('autoplay-') >= 0) {
                            switch (item.replace('autoplay-', '')) {
                                case 'slow' :
                                    autoplayTimeout = 10000;
                                    break;
                                case 'fast' :
                                    autoplayTimeout = 3000;
                                    break;
                                case 'normal' :
                                    autoplayTimeout = 5000;
                                    break;
                                default :
                                    autoplayTimeout = 0;
                            }
                        }
                    });

                    // slide video
                    $(this).on('click touch', '.link-video-embed.open-here', function (e) {
                        e.preventDefault();

                        $(this).addClass('hide');

                        // stop autoplay sur le slider
                        if ($(this).closest('.block-slider--content').hasClass('owl-carousel')) {
                            $(this).closest('.block-slider--content').trigger('stop.owl.autoplay');
                        }

                        // lecture video
                        $(this).closest('.paragraph--type--item-slider-slide').find('.content-video-embed').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
                        $(this).closest('.paragraph--type--item-slider-slide').addClass('play-video');
                    });

                    // init slider
                    $(this).find('.paragraph--type--item-slider-slide').each(function (index) {
                        $(this).attr('data-index', index + 1);
                    });
                    $(this).find('.block-slider--content').addClass('owl-carousel').owlCarousel({
                        loop: true,
                        autoplay: (autoplayTimeout > 0),
                        autoplayTimeout: autoplayTimeout,
                        responsiveClass: true,
                        autoplayHoverPause: true,
                        nav: $(this).hasClass('arrows'),
                        navText: [
                            '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-lg-small"></use></svg></div>',
                            '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-lg"></use></svg></div>'
                        ],
                        dots: $(this).hasClass('dots'),
                        autoWidth: false,
                        items: 1,
                        onChange: function (event) {
                            //console.log(event.property.name);
                            // si navigation dans slider en pause  suite à une lecture d'une vidéo : restart autoplay et stop vidéo
                            if (event.property.name == 'position') {
                                // restart autoplay
                                if ($(event.target).autoplay) {
                                    $(event.target).trigger('play.owl.autoplay');
                                }

                                // stop video
                                //console.trace($(event.target));
                                $(event.target).find('.paragraph--type--item-slider-slide').removeClass('play-video');
                                $(event.target).find('.paragraph--type--item-slider-slide .content-video-embed').empty();
                                $(event.target).find('.link-video-embed.hide').removeClass('hide');
                            }
                        },
                        onTranslated: function (event) {
                            var carousel = $(event.target);
                            var slideSelected = carousel.find('.owl-item').eq(event.item.index);
                            var index = slideSelected.find('.paragraph--type--item-slider-slide').attr('data-index');
                            index = (parseInt(index) < 10 ? '0' : '') + index;
                            carousel.closest('.paragraph--type--block-slider').find('.block-slider--nav .index').text(index);
                        }
                    });
                });
            }
        },
        /**
         * Block Thumb Gallery
         */
        initBlockThumbsGallery: function () {
            var self = this;

            if (self.elements.blockThumbGallery.length) {
                self.elements.blockThumbGallery.each(function () {
                    let displayThumbnail = ($(this).find('.field_thumbs_images > div').length > 1);
                    let sliderGallery = $(this).find('.field_thumbs_images');

                    // construction des miniatures
                    if (displayThumbnail) {
                        $(this).closest('.header-page--wrapper').addClass('withThumbnail');

                        $(this).append('<div class="thumbnail-gallery" />')
                        $(this).find('.field_thumbs_images > div').each(function () {
                          $(this).closest('.paragraph--type--block-thumbs-gallery').find('.thumbnail-gallery').append($(this).clone());
                        });

                        sliderGallery.on('translate.owl.carousel', function (event) {
                          let thumbItem = $(this).closest('.paragraph--type--block-thumbs-gallery').find('.thumbnail-gallery > div');
                          thumbItem.removeClass('active');
                          thumbItem.eq(event.item.index - 2).addClass('active');
                        });

                        sliderGallery.on('initialized.owl.carousel', function(e){
                          $(this).closest('.paragraph--type--block-thumbs-gallery').find('.thumbnail-gallery > div').eq(0).addClass('active');
                        });
                    }

                    // init slider
                    sliderGallery.addClass('owl-carousel').owlCarousel({
                        loop: true,
                        autoplay: false,
                        responsiveClass: true,
                        nav: false,
                        dots: false,
                        items: 1,
                        margin: 1
                    });

                    $('body').on('click touch', '.thumbnail-gallery > div', function(e) {
                        e.preventDefault();
                        $(this).closest('.paragraph--type--block-thumbs-gallery').find('.thumbnail-gallery > div').removeClass('active');
                        $(this).closest('.paragraph--type--block-thumbs-gallery').find('.field_thumbs_images').trigger('to.owl.carousel', [$(this).index()]);
                        $(this).addClass('active');
                    });
                });
            }
        },

        /**
         * Block Testimonials
         */
        initBlockTestimonials: function () {
            var self = this;

            if (self.elements.blockTestimonials.length) {
                self.elements.blockTestimonials.addClass('owl-carousel').owlCarousel({
                    loop: true,
                    autoplay: true,
                    responsiveClass: true,
                    autoplayHoverPause: true,
                    nav: true,
                    navText: [
                        '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-lg-small"></use></svg></div>',
                        '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-lg"></use></svg></div>'
                    ],
                    dots: false,
                    autoWidth: false,
                    items: 1
                });
            }
        },

        /**
         * Container Testimonials
         */
        initContainerTestimonials: function () {
            var self = this;

            if (self.elements.containerTestimonials.length) {
                if ($(window).outerWidth() > BREAKPOINT_DESKTOP) {
                    $(self.elements.containerTestimonials).each(function () {
                        var imgHeight = $(this).find('.header-slide-testimonials').innerHeight();
                        $(this).find('.body-slide-testimonials  .item-testimonials-testimony--text').css(
                            {
                                "margin-top": imgHeight + "px",
                            });
                    });
                }

                $(window).resize(function () {
                    if ($(window).outerWidth() > BREAKPOINT_DESKTOP) {
                        $(self.elements.containerTestimonials).each(function () {
                            var imgHeight = $(this).find('.header-slide-testimonials').innerHeight();
                            $(this).find('.body-slide-testimonials  .item-testimonials-testimony--text').css(
                                {
                                    "margin-top": imgHeight + "px",
                                });
                        });
                    } else {
                        $(self.elements.containerTestimonials).each(function () {
                            var imgHeight = $(this).find('.header-slide-testimonials').innerHeight();
                            $(this).find('.body-slide-testimonials  .item-testimonials-testimony--text').css(
                                {
                                    "margin-top": 0 + "px",
                                });
                        });
                    }
                });
            }
        },

        /**
         * Block Reassurance
         */
        initBlockReinssurance: function () {
            var containerReinssurance = $('.paragraph--type--container-reinssurance .paragraph--row');
            var params = {
                loop: true,
                autoplay: true,
                autoplayTimeout: 1500,
                responsiveClass: true,
                nav: false,
                dots: false,
                autoWidth: false,
                items: 1,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 3,
                    },
                }
            };

            if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
                containerReinssurance.addClass('owl-carousel').owlCarousel(params);
            }
            $(window).resize(function () {
                if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
                    if (!containerReinssurance.hasClass('owl-carousel')) {
                        containerReinssurance.addClass('owl-carousel').owlCarousel(params);
                    }
                } else {
                    if (containerReinssurance.hasClass('owl-carousel')) {
                        containerReinssurance.trigger('destroy.owl.carousel').removeClass('owl-carousel');
                    }
                }
            });
        },

        /**
         * Block Products cards
         */
        initBlockProductsCards: function () {
          $('body').on('click touch', '.paragraph--type--container-products-cards .btn-show-all', function (e) {
              e.preventDefault();

              $(this).closest('.paragraph--type--container-products-cards').find('.paragraph--row').addClass('show-all');
              $(this).hide();
          });
        },

        /**
         * Blocks Sliders for mobile
         */
        initSlidersForMobile: function (el) {
            var containerBlocks = $(el);
            var params = {
                loop: true,
                autoplay: false,
                responsiveClass: true,
                nav: false,
                dots: false,
                autoWidth: false,
                items: 1.2,
                margin: 25
            };

            if ($(window).outerWidth() < BREAKPOINT_TABLET) {
                containerBlocks.addClass('owl-carousel').owlCarousel(params);
            }
            $(window).resize(function () {
                if ($(window).outerWidth() < BREAKPOINT_TABLET) {
                    if (!containerBlocks.hasClass('owl-carousel')) {
                        containerBlocks.addClass('owl-carousel').owlCarousel(params);
                    }
                } else if (containerBlocks.hasClass('owl-carousel')) {
                    containerBlocks.trigger('destroy.owl.carousel').removeClass('owl-carousel');
                }
            });
        },

        /**
         * Block FAQ
         */
        initBlockFaq: function () {
            $('body').on('click touch', '.paragraph--type--block-faq .field_question', function (e) {
                e.preventDefault();
                $(this).addClass('selected');
                $(this).closest('.paragraph--type--block-faq').find('.field_question:not(.selected)').removeClass('active');
                $(this).removeClass('selected').toggleClass('active');
            });
        },

        /**
         * Block video
         */
        initBlockVideo: function () {
          $('body').on('click touch', '.paragraph--type--block-video-embed .block-video-embed--link.open-here', function (e) {
            e.preventDefault();
            if ($(this).data('video-type') == 'youtube') {
              $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<div class="youtube_player" videoID="' + $(this).data('video-id') + '" theme="dark" rel="0" controls="0" showinfo="1" autoplay="1" mute="0" srcdoc="" loop="0" loading="0"></div>');
              (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
            }
            else if ($(this).data('video-type') == 'vimeo') {
              $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<div class="vimeo_player" videoID="' + $(this).data('video-id') + '"></div>');
              (tarteaucitron.job = tarteaucitron.job || []).push('vimeo');
            }
            else if ($(this).data('video-type') == 'dailymotion') {
              $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<div class="dailymotion_player" videoID="' + $(this).data('video-id') + '" showinfo="1" autoplay="0" embedType="video"></div>');
              (tarteaucitron.job = tarteaucitron.job || []).push('dailymotion');
            }
            else {
              $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
            }
            $(this).closest('.paragraph--type--block-video-embed').addClass('play');
          });
        },

        /**
         * Refresh header sticky
         */
        refreshHeaderSticky: function () {
            if ($(window).scrollTop() > 50) {
                $('body').addClass('header-sticky');
            }
            else {
                $('body').removeClass('header-sticky');
            }
        },

        /**
         * Block Slider meats
         */
        initSliderMeats: function () {
          var self = this;

          if (self.elements.blockSliderMeats.length) {
            self.elements.blockSliderMeats.each(function () {
              let displayThumbnail = ($(this).find('.image-catalog').length > 1);
              let blockSliderMeats = $(this).find('.images-catalog');

              // construction des miniatures
              if (displayThumbnail) {
                $(this).append('<div class="thumbnail-gallery" />')
                $(this).find('.image-catalog').each(function () {
                  $(this).closest('.field_image_catalog').find('.thumbnail-gallery').append($(this).clone());
                });

                blockSliderMeats.on('translate.owl.carousel', function (event) {
                  let thumbItem = $(this).closest('.field_image_catalog').find('.thumbnail-gallery .image-catalog');
                  thumbItem.removeClass('active');
                  //thumbItem.eq(event.item.index - 2).addClass('active');
                  thumbItem.eq($(this).data('owl.carousel').relative(event.item.index)).addClass('active');
                });

                blockSliderMeats.on('initialized.owl.carousel', function (e) {
                  $(this).closest('.field_image_catalog').addClass('withThumbnail')
                    .find('.thumbnail-gallery .image-catalog').eq(0).addClass('active');
                });

                // init slider
                blockSliderMeats.addClass('owl-carousel').owlCarousel({
                  loop: true,
                  autoplay: false,
                  responsiveClass: true,
                  nav: false,
                  dots: false,
                  items: 1,
                  autoWidth: false,
                  margin: 2
                });

                $('body').on('click touch', '.thumbnail-gallery .image-catalog', function(e) {
                  e.preventDefault();
                  $(this).closest('.field_image_catalog').find('.thumbnail-gallery .image-catalog').removeClass('active');
                  $(this).closest('.field_image_catalog').find('.images-catalog').trigger('to.owl.carousel', [$(this).index()]);
                  $(this).addClass('active');
                });
              }
            });
          }
        },


        /**
         * initEffectsOnScroll  (optionnel)
         * Requiert scrollreveal : à activer dans site.json ("./node_modules/scrollreveal/dist/scrollreveal.min.js")
         */
        /*initEffectsOnScroll: function (){
          var optionReset = false;
          var optionDelay = 200;
          var options;
          var delai;

          // animation des titres
          options = { reset: optionReset, delay: 0, duration: 800, distance: '50px', origin: 'left', opacity: 0, interval: 150 };
          ScrollReveal().reveal(
              '.effects-enabled .content-page-header--wrapper .title1, ' +
              '.effects-enabled .content-page-header--wrapper .field_header_text',
              options
          );
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0 };
          ScrollReveal().reveal('.effects-enabled .paragraph--type--item-container-header', options);

          // animation des chiffres
          options = {reset: optionReset, delay: 0, duration: 600, origin: 'bottom', opacity: 0,
              afterReveal: function (el) {
                  var all = Drupal.Theme.load('all');
                  all.animateNumber($(el));
              }
          };
          ScrollReveal().reveal('.effects-enabled .wysiwyg .numerator', options);

          // animation des icônes réseaux sociaux du footer
          options = {reset: optionReset, delay: optionDelay, duration: 1000, origin: 'bottom', opacity: 0, scale: 1.5 };
          ScrollReveal().reveal($('.effects-enabled').closest('body').find('#block-menu-social-media .level0--item'), options);

          // animation des cards se trouvant dans des vues
          options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
          ScrollReveal().reveal($('.effects-enabled .views-element-container .view-list--wrapper > .view-item'), options);

          // animation des questions de la faq
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'right', opacity: 0, interval: 200 };
          ScrollReveal().reveal($('.effects-enabled .paragraph--type--block-faq .field_question'), options);

          // animation pour les boutons
          options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 100 };
          ScrollReveal().reveal($('.effects-enabled .paragraph-root .btn, .paragraph-root .button'), options);

          // animation paragraphe citation
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 1.5, interval: 200 };
          ScrollReveal().reveal(
              $('.effects-enabled .paragraph--type--block-citation .field_sentence'),
              options
          );
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
          ScrollReveal().reveal(
              $('.effects-enabled .paragraph--type--block-citation .field_author, ' +
                  '.effects-enabled .paragraph--type--block-citation .field_author_title'),
              options
          );

          // animation alternée des paragraphes roots
          var cptParagraphRoot = 0;
          $('.effects-enabled .paragraph-root').each(function (index) {

              // animation pour paragraphe de type "2 colonnes"
              if ($(this).hasClass('paragraph--type--container-2col') ||
                  $(this).hasClass('paragraph--type--container-2wysiwyg') ||
                  $(this).hasClass('paragraph--type--container-faq') ||
                  $(this).hasClass('paragraph--type--container-image-text') ||
                  $(this).hasClass('paragraph--type--container-video-text')) {

                  // sous paragraphes
                  $(this).find('.paragraph--row > *').each(function (index) {
                      if ($(this).closest('.paragraph-root').hasClass('display-rtl')) {
                          var origin = (index % 2 == 0 ? 'right' : 'left');
                      }
                      else {
                          var origin = (index % 2 == 0 ? 'left' : 'right');
                      }
                      options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                      ScrollReveal().reveal($(this), options);
                  });
              }
              // animation pour paragraphe contenant des cards
              else if ($(this).hasClass('paragraph--type--container-3col') ||
                  $(this).hasClass('paragraph--type--container-4col') ||
                  $(this).hasClass('paragraph--type--container-reinssurance') ||
                  $(this).hasClass('paragraph--type--container-content-custom')) {
                  options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
                  ScrollReveal().reveal($(this).find('.paragraph--row .paragraph--type--block-card'), options);
              }

              // animation pour paragraphe chronologie
              else if ($(this).hasClass('paragraph--type--container-chronology')) {
                  // sous paragraphes
                  $(this).find('.chronology--item-text').each(function (index) {
                      var origin = (index % 2 == 0 ? 'left' : 'right');
                      options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                      ScrollReveal().reveal($(this), options);
                  });
              }

              // animation pour paragraphe galery
              else if ($(this).hasClass('paragraph--type--container-galery')) {
                  options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
                  ScrollReveal().reveal($(this).find('.paragraph--type--block-image'), options);
              }
              // animations pour paragraphes de type "multilignes"
              else if ($(this).hasClass('paragraph--type--container-col2-texts')) {
                  cptParagraphRoot++;

                  // sous paragraphes
                  $(this).find('.container-col2-texts--content > li').each(function (index) {
                      var origin = (index % 2 == 0 ? 'right' : 'left');
                      options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                      ScrollReveal().reveal($(this), options);
                  });
              }
              // animation pour autres paragraphes
              else if (!$(this).hasClass('paragraph--type--container-wysiwyg') &&
                  !$(this).hasClass('paragraph--type--container-citation') &&
                  !$(this).hasClass('paragraph--type--container-webform')) {
                  cptParagraphRoot++;

                  var origin = (index % 2 == 0 ? 'right' : 'left');
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              }
          });
        },*/

    };

}(jQuery, Drupal, drupalSettings));
